import React, { useContext } from "react";
import { appContext } from "../App";

function Category(props: { value: string; count: number }) {
  const { category, updateCategory } = useContext(appContext);

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    event.stopPropagation();
    updateCategory(category === props.value ? null : props.value);
  };
  return (
    <li
      className={category === props.value ? "filter-remove" : "filter"}
      style={{ fontSize: "0.7vx" }}
    >
      <a href="#" className="list-group-item" onClick={handleClick}>
        {props.value} - {props.count}
      </a>
    </li>
  );
}

export default Category;
